import { render, staticRenderFns } from "./TheGetTheAppButton.vue?vue&type=template&id=fd74ada0"
import script from "./TheGetTheAppButton.vue?vue&type=script&lang=js"
export * from "./TheGetTheAppButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports